import { AuthResponseInterface } from "app/modules/user/models/auth/auth.response.interface";
import { AuthModelInterface } from "app/modules/user/models/auth/auth.model.interface";
import { OTP_TYPE } from "app/shared/components/2fa-dialog/2fa-set-up-dialog.component";
export class AuthModel implements AuthModelInterface {
  username?: string;
  access: string;
  refresh: string;
  verify_token?: string;
  otp_type?: OTP_TYPE;
  otp_send_failed?: boolean;
  message?: string;

  static fromResponse(response: AuthResponseInterface): AuthModel {
    const user = new AuthModel();
    // user.username = response.username; //
    user.access = response.access;
    user.refresh = response.refresh;
    user.verify_token = response.verify_token;
    user.otp_type = response.otp_type === "Device" ? OTP_TYPE.DEVICE : OTP_TYPE.EMAIL;
    user.otp_send_failed = response.otp_send_failed;
    user.message = response.message;
    return user;
  }

  constructor() {}
}
